import React from 'react';
import Slider from 'react-slick';

const ClientSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,  // Enable auto sliding
    autoplaySpeed: 2000, // Set the time interval between slides (in milliseconds)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className='container'>

<div className="twm-client-slider1-wrap site-bg-white container">
      <div className="twm-client-slider1 container">
        <Slider {...settings} className="home-client-carousel3 owl-btn-vertical-center">
          {/* Slider Item 1 */}
          <div className="item ">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w1.png" alt="Client 1" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 2 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w2.png" alt="Client 2" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 3 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w3.png" alt="Client 3" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 4 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w4.png" alt="Client 4" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 5 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w5.png" alt="Client 5" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 6 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w6.png" alt="Client 6" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 7 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w1.png" alt="Client 7" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 8 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w2.png" alt="Client 8" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 9 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w3.png" alt="Client 9" />
                </a>
              </div>
            </div>
          </div>

          {/* Slider Item 10 */}
          <div className="item">
            <div className="ow-client-logo">
              <div className="client-logo client-logo-media">
                <a href="cars-grid-4.html">
                  <img src="images/client-logo/dark/w5.png" alt="Client 10" />
                </a>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>

    </div>
  );
};

export default ClientSlider;
